var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0C22.5037 0 29 6.49629 29 14.5C29 22.5037 22.5037 29 14.5 29C6.49629 29 0 22.5037 0 14.5C0 6.49629 6.49629 0 14.5 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0C22.5037 0 29 6.49629 29 14.5C29 22.5037 22.5037 29 14.5 29C6.49629 29 0 22.5037 0 14.5C0 6.49629 6.49629 0 14.5 0Z",
    fill: "#FFA112"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2742 6.91296L22.9348 17.0839C23.6178 18.3099 23.684 19.5203 23.1214 20.4921C22.5592 21.4648 21.482 22 20.0886 22H8.91174C7.51834 22 6.44093 21.4644 5.87833 20.4921C5.31613 19.5203 5.38233 18.3095 6.06473 17.0839L11.7266 6.91296C12.4134 5.67949 13.3986 5 14.5006 5C15.6024 5 16.587 5.67949 17.2742 6.91296ZM20.0888 20.5157C20.9388 20.5157 21.5658 20.2417 21.8536 19.7435C22.1416 19.2455 22.0708 18.5595 21.6552 17.8119L15.9942 7.64076C15.7536 7.20905 15.2396 6.48449 14.5008 6.48449C13.7614 6.48449 13.2476 7.20905 13.0072 7.64116L7.34514 17.8119C6.92893 18.5597 6.85873 19.2455 7.14674 19.743C7.43494 20.2417 8.06194 20.5157 8.91194 20.5157H20.0888Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5006 16.9194C13.8386 16.9194 13.3004 17.4637 13.3004 18.1333C13.3004 18.8021 13.8386 19.3458 14.5006 19.3458C15.1622 19.3458 15.7004 18.8021 15.7004 18.1333C15.7004 17.4637 15.1622 16.9194 14.5006 16.9194Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6905 15.1045L13.6995 15.2521C13.7093 15.6897 14.0645 16.0427 14.5001 16.0427C14.9415 16.0427 15.3007 15.6799 15.3005 15.2489L15.3003 15.2412C15.3863 13.9327 15.6035 10.5975 15.6091 10.4859L15.6099 10.4595C15.6091 9.85112 15.1117 9.35596 14.5005 9.35596C13.8887 9.35596 13.3911 9.8588 13.3911 10.4769L13.3921 10.5064C13.3953 10.5617 13.5005 12.1891 13.6905 15.1045Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c1df59ff.svg";
export { ForwardRef as ReactComponent };